exports.components = {
  "component---src-pages-confirmacoes-js": () => import("./../../../src/pages/confirmacoes.js" /* webpackChunkName: "component---src-pages-confirmacoes-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-presentes-js": () => import("./../../../src/pages/presentes.js" /* webpackChunkName: "component---src-pages-presentes-js" */)
}

